var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"c-header header"},[_c('AppHeaderLogo',{staticClass:"header__title"}),_c('h2',{staticClass:"header__subtitle"},[_vm._v(" "+_vm._s(_vm.$translate('FIFTEEN_PUZZLE'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }